import $, { extend } from 'jquery';
import React from 'react';
import {UserToken,getUserObjData} from '../function_lib/userToken';
import {CallMapMethod,AjaxCallMethod,CallMapMethod_CBack,validateNumberLength,
  TableDatePicker,exportTableToCSV} from '../function_lib/common_lib';

import {Custom_Alert,Alert_Content} from '../components/custom_alert';

import Header from '../user_pages/header';
import Footer from '../user_pages/footer';
import Comp_Enable_Disable from '../components/comp_enable_disable';
import Option_Module from '../user_pages/option_module';
import LogoImg from '../assets/images/logo_p_small.png';
import defaultPic from '../assets/images/9.png';

import Wa_Credit_Balance_Comp from '../components/wa_credit_balance';



let loginUser="";
let userObject="";
let companyName="";
let clsUserMgmt;

let rf="0";
class Manage_Users extends React.Component{
  forceUpdateHandler(){
    this.forceUpdate();
  };

    constructor(props){
        super(props);
        if(localStorage.getItem("userData")!=null){
          userObject= getUserObjData();
          //alert(JSON.stringify(userObject));
          loginUser=userObject[0].first_name;
          companyName=userObject[0].first_name;
      }
      this.state={ listUsers:[],stListStates:[],creditBalance:[],masterBalance:[],
      stEditAppUser:{}};
          this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
      clsUserMgmt=this;
      }

      resetFilters(){
        $("#ser_text").val("");
        clsUserMgmt.getUsers();
      }

      okSuccUser(data,msg){
        if(data==="001"){
          alert("Record Updated Successfully..");
          clsUserMgmt.getUsers();

        }
      }


      getUsers(status="0"){
        //child component use this method loan_document_upload_comp
        let ser_status="0";
        if($("#ser_status").prop("checked")){
          ser_status="Active";
        }else{
          ser_status="0";
        }
        var map=[];
        map.push({name:"curl_type",value:"getAppUsers"});
        map.push({name:"res_func",value:"callBackrrr"});
        map.push({name:"gb_token",value:userObject[0].app_user_id});
        map.push({name:"user_type",value:"2"});
        map.push({name:"ser_status",value:ser_status});
        //map.push({name:"ser_userType",value:$("#ser_userType").val()});
        map.push({name:"ser_text",value:$("#ser_text").val()});
        //alert(status);
        /*
        if(status!=="0"){
          map.push({name:"status",value:status});
        }
        not required as of now
        */
        map.push({name:"app_user_id",value:userObject[0].upper_id});
        map["res_func"]="callBackrrr";
        map["curl_type"]="getAppUsers";
        CallMapMethod_CBack(clsUserMgmt,map,function(data,msg){
          //alert(data);
            if(data!=="0" && data!==""){
                let listData=JSON.parse(data);
                var strData="";
                clsUserMgmt.setState({listUsers:listData},()=>{
                  //window.getPagination("#tbData");
                  clsUserMgmt.forceUpdateHandler();
                  //RespBkMthdMapp(clsUserMgmt,"_btnShareOption","");
                 
                  if(rf!=="0"){
                    clsUserMgmt.getSearch(rf);
                    //alert("i m in setup "+rf);
                    $("#serLoanStatus").val(rf);
                  }
                });
              }
        });
      }
      okSucc(data,smg){
        if(data==="001"){
          //alert("record added successfully");
          Custom_Alert("Successful","Record Added Successfully",false);
          window.location.reload();
          //clsUserMgmt.getUsers();
          //$("#frmCreate").find("input[type=text]").val("");
        }else{
          //alert(smg);
          Custom_Alert("Invalid",smg,false);
        }
        // alert(data);
      }
okSuccCreditB(data,msg){
  //alert(data);
  if(data===-10){
    Custom_Alert("Validation","Fill Required Fileds",false);
    
    return;
  }else{
    //alert(data+msg);
    Custom_Alert("Completed",msg,true);
    
  }
    
}


getStates(){
  var map=[];
  map.push({name:"curl_type",value:"getStates"});
  map.push({name:"res_func",value:"callBackrrr"});
  map.push({name:"gb_token",value:userObject[0].app_user_id});
 
  
  map["res_func"]="callBackrrr";
  map["curl_type"]="getStates";
  CallMapMethod_CBack(clsUserMgmt,map,function(data,msg){
    //alert(data);
      if(data!=="0" && data!==""){
         let lsData=JSON.parse(data);
         clsUserMgmt.setState({stListStates:lsData})
        }
  });
}

exportExcel(elementId,ignoreCol,expFileName){
  exportTableToCSV(elementId,ignoreCol,expFileName);
}           
      
componentDidMount(){
    
  AjaxCallMethod(this,"okSuccCNOT");
$("#app_user_id").val(userObject[0].app_user_id);
this.getStates();
this.getUsers();

$('#divCreateUser').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  clsUserMgmt.setState({stEditAppUser:{"nn":"00"}});
  clsUserMgmt.forceUpdateHandler();
 
});

$('#divEnableDisable').on('hidden.bs.modal', function () {
  //alert("i m in hide");
  clsUserMgmt.setState({stEditAppUser:{"nn":"00"}});
  clsUserMgmt.forceUpdateHandler();
 
});

}
onEditAppUser(item){
  // alert(JSON.stringify(item));
  clsUserMgmt.setState({stEditAppUser:item});

}


      render(){
          return(<div>
<Header/>
<div className="content">
<div className="container-fluid mt-4">
<div className="row content12 mt-2 mb-2">
{/* 
<div className="col-lg-2 col-md-2 col-sm-4 float-right">
<select  className="form-control form-control-sm" id="ser_userType" name="ser_userType">
           <option value="0">-User Type-</option>
           <option value="3">-User-</option>
          
         </select>
</div> */}

<div className='col-lg-4 col-md-4 col-sm-4 float-right'>
<div className="form-group">
         <div className="input-group">
               <input autoComplete='off' type="text" id="ser_text" name="ser_text" rf="#btnUserSearch" className="_setSearchKeyUp keyEvent_btn form-control form-control-sm" placeholder='search' />
             </div>
         
         </div>

</div>
<div className="col-lg-2 col-md-2 col-sm-4 float-right">
  
  <input type='checkbox' defaultChecked={true} onClick={()=>this.getUsers()} class="form-control-sm" id="ser_status" name="ser_status"/>
  <label for="ser_status">
    Hide Inactive
  </label>

</div>

<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 <div onClick={()=>this.getUsers()}  style={{marginRight:"10px"}} id="btnUserSearch" name="btnUserSearch" className="btn btn-sm btn-danger">Search</div>
                 <div onClick={()=>this.resetFilters()}  className="btn btn-sm btn-danger">Reset</div>
                 </div>
               </div>
             </div>

</div>


<div className="col-lg-2 col-md-2 col-sm-4 vcenter-item1 float-right">
<div className="input-group">
               
               <div className="input-group-prepend">
               <div className='col-12 '>
                 {/* <div id="btnProSearch" name="btnProSearch"  style={{marginRight:"10px"}} className="btn btn-sm btn-secondary">Export Pdf</div> */}
                 <div onClick={()=>this.exportExcel("tbData","Detailed Log","Users_Data_CSV")}  className="btn btn-sm btn-primary">Export Excel</div>
                 </div>
               </div>
             </div>

</div>
    </div>    
<div className="row">
      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
         
      <div class="card">
              {/* <!-- /.card-header --> */}
           <div class="card-header bg-cyan">
                <h3 class="card-title "><b>Users List</b></h3>
                
                <a className="btn btn-sm btn-danger float-right" data-toggle="modal" data-target="#divCreateUser" href="javascript:void(0)">Add New</a>
              </div>
                <table id="tbData" class="dtgrid dtgrid table table-bordered table-hover text-sm text-nowrap1 table-responsive">
                  <thead>
                    <tr class="border">
                      <th>S.No.</th>
                      <th>Name</th>
                      <th>Employee Id</th>
                      <th>Contact Number</th>
                      <th>Email Id</th>
                      <th>State</th>
                      <th>City</th>
                      <th>Status</th>
                      <th>Enrollment Date</th>
                      
                      {/* <th>Status</th> */}
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {(this.state.listUsers.map((item,index)=>{
                       return(<tr>
                        <td>{index+1}</td>
                    
                  <td>{item.business_name}</td>
                  <td>{item.person_name}</td>
                  <td>{item.contact_no}</td>
                  <td>{item.email}</td>
                  <td>{item.state_name}</td>
                  <td>{item.city_name}</td>
                
                  <td><span className="badge bg-danger dash_rejected_claim1">{item.status}</span></td>
                  <td>{item.fmt_entry_date}</td>
                  <td>
                  <div class="btn-group">
                    <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" area-expanded="false">
                      Action
                    </button>
                    <div class="dropdown-menu">
                     <a class="dropdown-item" onClick={()=>this.onEditAppUser(item)} data-toggle="modal" data-target="#divCreateUser" href="javascript:void(0)">Edit</a>
                     {/* {typeof _objAccess.can_delete!=="undefined" && item.stu_invoice_id!=="" && item.stu_invoice_id!==null?<a class="dropdown-item red" onClick={()=>this.onStudentInvBreakdown(item,true)} data-toggle="modal" data-target="#divStuInvBreakdown" href="javascript:void(0)">Delete Fee Invoice</a>:''} */}
                     <a class="dropdown-item" onClick={()=>this.onEditAppUser(item)} data-toggle="modal" data-target="#divEnableDisable" href="javascript:void(0)">Activate/Deactivate</a>
                    </div>
                  </div>
                  </td>
                    </tr>)
                  }))}
                  </tbody>
                </table>
                <div class='pagination-container' >
				<nav>
				  <ul class="pagination">
            
            <li data-page="prev" >
								     <span> {"<"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  
        <li data-page="next" id="prev">
								       <span> {">"} <span class="sr-only">(window.current)</span></span>
								    </li>
				  </ul>
				</nav>
			</div>
              {/* <!-- /.card-body --> */}
            </div>
      </div>
</div>
</div>
</div>
<Alert_Content/>
<Comp_Enable_Disable user_object={userObject} editItem={this.state.stEditAppUser} cUrls={"editAppUsersStsts"} />
<Footer/>

<div className="modal fade bd-example-modal-xl"  id="divCreateUser" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog modal-xl" role="document">
    <div className="modal-content">
    <div className="modal-header bg-primary">
        <h5 className="modal-title text-white" id="exampleModalLabel">{typeof this.state.stEditAppUser.id!=="undefined"?"Edit User":"Add New User"}</h5>
        <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" className="text-white">&times;</span>
        </button>
      </div>
      <form id="frmCreateUsers" name="frmCreateUsers">
     
      <div className="modal-body">
      <div className="row">
                {/* <!-- left column --> */}
                <div className="col-md-12">
                    <div className="card card-danger">
                            <input type="hidden" name="res_func" id="res_func" value="okSucc" />
                            <input type="hidden" name="curl_type" id="curl_type" value="create_user" />
                            <input type="hidden" name="m_type" id="m_type" value="create_user" />
                            <input type="hidden" name="type_id" id="type_id" value="2" />
                            <input type="hidden" name="gb_token" id="gb_token" value={userObject[0].app_user_id} />
                            <input type="hidden" name="app_users_id" id="app_users_id" value={typeof this.state.stEditAppUser.id==="undefined"?"0":btoa(this.state.stEditAppUser.id)}/>
                            <div className="card-body">
                                <div className="row">
                               
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="business_name" name="business_name" defaultValue={this.state.stEditAppUser?.business_name} className="form-control required" placeholder="Name" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Emp ID</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="dealer_code" name="dealer_code" defaultValue={this.state.stEditAppUser?.person_name} className="form-control required" placeholder="Emp ID" />
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">In-Charge Name</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="person_name" name="person_name" className="form-control required11" placeholder="In-Charge Name" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Contact No.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="number" onChange={()=>validateNumberLength("contact_no",10)} defaultValue={this.state.stEditAppUser?.contact_no} id="contact_no" name="contact_no" maxlength={10} className="form-control required" placeholder="10 Digit No." />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Email Id.</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="email" name="email" defaultValue={this.state.stEditAppUser?.email} className="form-control required11" placeholder="Email Id" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">State</label>
                                            <div className="input-group input-group-sm">
                                              <select id="state_id" name="state_id" className="form-control required">
                                                <option>-Select-</option>
                                                {this.state.stListStates.map((item,index)=>{
                                                  return <option selected={this.state.stEditAppUser?.state_id===item["id"]} value={btoa(item["id"])}>{item["name"]}</option>
                                                })}
                                              </select>
                                                
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-4">
                                        <div className="form-group">
                                            <label for="exampleInputEmail1">City</label>
                                            <div className="input-group input-group-sm">
                                                <input type="text" id="city_name" defaultValue={this.state.stEditAppUser?.city_name} name="city_name" className="form-control required" placeholder="City Name" />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                              
                                <div className="col-md-6 respSSL"></div>
                                <div id="testing2dd2222"></div>
                            </div>
                        
                    </div>
                </div>
            </div>
      </div>
      <div className="modal-footer">
      <div id="getReponse" style={{color:"red"}}></div>
        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" className="btn _btnSetColor btn-primary">Save changes</button>
      </div>
      </form>
    </div>
    </div>
    </div>
    
          </div>)
      }
}
export default Manage_Users;